import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { switchMap, catchError, take } from 'rxjs/operators';
import { AuthService } from '@auth0/auth0-angular';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {  

  constructor(private authService: AuthService) {}

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.authService.isAuthenticated$.pipe(
      take(1),
      switchMap(isAuthenticated => {
        if (!isAuthenticated) {
          return next.handle(request);
        }

        return this.authService.getAccessTokenSilently().pipe(
          catchError(error => {
            console.warn('Failed to retrieve access token, proceeding without authorization header:', error);
            return of(null);
          }),
          switchMap(token => {
            if (token) {
              const modifiedRequest = request.clone({
                setHeaders: {
                  'Authorization': `Bearer ${token}`
                }
              });
              return next.handle(modifiedRequest);
            } else {
              return next.handle(request);
            }
          })
        );
      })
    );
  }
}
